var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77612 22.0432L3.20599 16.8325C2.32264 15.304 1.85864 13.57 1.86077 11.8054C1.8631 6.26091 6.38378 1.75024 11.939 1.75024C14.6348 1.75161 17.1651 2.79869 19.0681 4.69939C20.9711 6.60009 22.0181 9.12652 22.0172 11.8135C22.0147 17.3575 17.4933 21.869 11.9389 21.869H11.9345C10.248 21.8683 8.59071 21.446 7.11865 20.6449L1.77612 22.0432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9418 3.44875C7.32127 3.44875 3.56366 7.1978 3.56202 11.8059C3.55974 13.3795 4.00371 14.9215 4.84259 16.2538L5.04189 16.5701L4.19552 19.654L7.36592 18.8243L7.67206 19.0053C8.95783 19.7669 10.4321 20.1697 11.9355 20.1705H11.9387C16.5556 20.1705 20.3132 16.421 20.315 11.8126C20.3185 10.7142 20.1037 9.62606 19.6829 8.6111C19.2622 7.59614 18.6439 6.67456 17.8639 5.89972C17.0882 5.12064 16.1653 4.50286 15.1488 4.08215C14.1323 3.66144 13.0423 3.44615 11.9418 3.44875Z",
    fill: "url(#paint0_linear_17683_33808)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41986 7.6017C9.23111 7.18322 9.03249 7.17475 8.85319 7.1675L8.3705 7.16162C8.20257 7.16162 7.92972 7.22451 7.69905 7.47606C7.46839 7.72761 6.81763 8.33556 6.81763 9.57212C6.81763 10.8087 7.72001 12.0035 7.84575 12.1714C7.97149 12.3393 9.58778 14.9577 12.1474 15.9652C14.2745 16.8024 14.7073 16.6359 15.1692 16.594C15.6311 16.5522 16.6591 15.9861 16.8688 15.3992C17.0785 14.8123 17.0786 14.3095 17.0157 14.2043C16.9529 14.0992 16.7849 14.0367 16.5329 13.9109C16.2809 13.7852 15.043 13.1772 14.8122 13.0933C14.5814 13.0093 14.4136 12.9676 14.2456 13.2192C14.0775 13.4707 13.5955 14.0366 13.4485 14.2043C13.3016 14.3721 13.1549 14.3931 12.9028 14.2675C12.6508 14.1418 11.8399 13.8763 10.8778 13.0201C10.1292 12.3539 9.62395 11.5312 9.47684 11.2798C9.32973 11.0284 9.46122 10.8922 9.58751 10.767C9.70051 10.6543 9.83927 10.4735 9.96542 10.3268C10.0916 10.1801 10.1331 10.0752 10.2169 9.90775C10.3007 9.74028 10.259 9.59317 10.1959 9.46754C10.1329 9.3419 9.64367 8.09878 9.41986 7.6017Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17683_33808",
    x1: 11.768,
    y1: 4.45222,
    x2: 11.8526,
    y2: 18.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.f11ee41a8320139158142a51a0678d70.svg";
export { ForwardRef as ReactComponent };